import { render, staticRenderFns } from "./PowerDevice.vue?vue&type=template&id=25b61bc3&scoped=true"
import script from "./PowerDevice.vue?vue&type=script&lang=js"
export * from "./PowerDevice.vue?vue&type=script&lang=js"
import style0 from "./PowerDevice.vue?vue&type=style&index=0&id=25b61bc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b61bc3",
  null
  
)

export default component.exports